import MediaItem from './MediaItem';

export default class PresetMedia extends MediaItem {
  lastPreset = null;
  preset = null;

  constructor(model, app) {
    super(app, true);

    this.createPreset(model);
    this.updateModel(model);
  }

  render() {
    super.render();
    this.preset.render();
  }

  createPreset(model) {
    // overwritten by subclasses
  }

  setPreset(preset, presetKey) {
    this.lastPreset = presetKey;
    this.preset = preset;
    this.container.removeChildren();
    this.container.addChild(this.preset.parent);
  }

  /**
   * Avoid creating a new preset unless the model
   * preset selection has changed.
   *
   * @param model
   */
  updateModel(model) {
    if (this.lastPreset !== model.animationPreset) {
      this.createPreset(model);
    }

    this.preset.update(model);

    super.updateModel(model);
  }

  get greensockTimeline() {
    return this.preset.timeline;
  }
}
